
import axios from '@/utils/axios.js'

//banner
export const getBanner = (data) => {
    return axios.request({
        url: `/banner`,
        data,
        method: 'get'
    })
}
//合作伙伴
export const getPartner = (data) => {
    return axios.request({
        url: `/partners`,
        data,
        method: 'get'
    })
}
//公司动态
export const getCompany = (data) => {
    return axios.request({
        url: `/companyDynamics?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
        data: {},
        method: 'get'
    })
}

//荣誉资质
export const getQualifications = (data) => {
    return axios.request({
        url: `/honoraryQualifications`,
        data,
        method: 'get'
    })
}
//视频
export const getVideo = (data) => {
    return axios.request({
        url: `/video`,
        data,
        method: 'get'
    })
}
//解决方案
export const getDocumentation = (data) => {
    return axios.request({
        url: `/documentation`,
        data,
        method: 'get'
    })
}

//解决方案详情
export const getDetail = (data) => {
    return axios.request({
        url: `/documentationDetail?type=${data}`,
        data: {},
        method: 'get'
    })
}
//经典案例
export const getCases = (data) => {
    return axios.request({
        url: `/classicCases`,
        data,
        method: 'get'
    })
}
//联系我们
export const getUs = (data) => {
    return axios.request({
        url: `/contactUs`,
        data,
        method: 'get'
    })
}
//发展历程
export const getHistory = (data) => {
    return axios.request({
        url: `/developmentHistory`,
        data,
        method: 'get'
    })
}
//产品矩阵
export const getProduct = (data) => {
    return axios.request({
        url: `/product`,
        data,
        method: 'get'
    })
}

// 公司业务-官网C端列表查询
export const getBusiness = (data) => {
    return axios.request({
        url: `/app/list`,
        method: 'get'
    })
}

// 公司基本信息C端查询
export const getInfoDetail = (data) => {
    return axios.request({
        url: `/company/info/detail`,
        method: 'get'
    }) 
}

// 友情链接列表
export const getLinks = () => {
    return axios.request({
        url: `/friend/links`,
        method: 'post'
    }) 
}

// 增加PV
export const addPV = () => {
    return axios.request({
        url: `/visit/pv`,
        method: 'get'
    }) 
}
// 增加UV
export const addUV = () => {
    return axios.request({
        url: `/visit/uv`,
        method: 'get'
    })
}

// 文旅创新详情
export const getInnovateDetail = () => {
    return axios.request({
        url: `/tour/innovate/detail`,
        method: 'get'
    }) 
}

// 添加留言信息
export const addMessage = (data) => {
    return axios.request({
        url: `/messageBoard/add`,
        method: 'post',
        data
    })
}